import { Skeleton, Typography } from '@mui/material';
import { isEmptyString } from '@weft/utils';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { useCustomer } from '../../../hooks/requests/use-customer';
import { useValidatedParams } from '../../../hooks/use-validated-params';
import { useCustomerPageTabs } from '../CustomerOverviewPage/customer-view-page-hooks/use-customer-page-tabs';

export const CustomerIdPage: React.FC<PropsWithChildren> = ({ children }) => {
  const { customerId } = useValidatedParams('customerId');
  const { data, isLoading } = useCustomer(customerId, { suspense: false });
  const [customerPageTabs, currentCustomerTab] = useCustomerPageTabs();

  return (
    <VyPageLayout
      path={isLoading ?
        [<NavLink to="/customers">Customers</NavLink>] :
        [<NavLink to="/customers">Customers</NavLink>, data?.customer.name]
      }
      title={(
        isEmptyString(data?.customer.name) ?
          <Skeleton
            variant="text"
            width={200}
          /> :
          <Typography variant="h5">
            {data?.customer.name}
          </Typography>
      )}
      currentTab={currentCustomerTab}
      tabs={customerPageTabs}
      showBackButton
    >
      {children}
    </VyPageLayout>
  );
};